// extracted by mini-css-extract-plugin
export var actions = "_2p-0";
export var actionsContainer = "_2p-7";
export var border = "_2p-1";
export var childFullHeight = "_2p-f";
export var collapse = "_2p-2";
export var content = "_2p-a";
export var contentChild = "_2p-e";
export var fullscreen = "_2p-c";
export var hasLeftRadius = "_2p-k";
export var headerContainer = "_2p-3";
export var headerRow = "_2p-5";
export var hidePadding = "_2p-b";
export var navCollapsedGap = "_2p-l";
export var noScrollX = "_2p-m";
export var noScrollY = "_2p-n";
export var noTopPadding = "_2p-i";
export var optOutTopPadding = "_2p-d";
export var pageMain = "_2p-j";
export var pageOuter = "_2p-g";
export var pagePadding = "_2p-8";
export var pageScroll = "_2p-9";
export var profile = "_2p-o";
export var profileContainer = "_2p-p";
export var profileImage = "_2p-q";
export var profileMain = "_2p-r";
export var profileSubtitle = "_2p-t";
export var profileTitle = "_2p-s";
export var showLeftPadding = "_2p-h";
export var tabsPortalSlot = "_2p-6";
export var tabsWrapper = "_2p-4";
export var title = "_2p-u";